import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";


const DisplayShippingChart = ({ key, traceabilityScoreData }) => {
	const { t } = useTranslation();
	const lowColor = '#0da30d';
	const highColor = '#f19d02';
	const medColor = '#FFFF00';
	const noColor = '#e2e5e9';

	return (
		<div key={key}>
			<div className="row">
				<div className="col-sm-6">
				</div>
				<div className="col-sm-6">
					<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.eval.level") + ' '}</b></h6>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
				</div>
				<div className="col-sm-6">
					<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.ready") + ' '}</b><span className="badge result-pass-sm"> </span></h6>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
				</div>
				<div className="col-sm-6">
					<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.inspect") + ' '}</b><span className="badge result-medium-sm"> </span></h6>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
				</div>
				<div className="col-sm-6">
					<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.pause") + ' '}</b><span className="badge result-fail-sm"> </span></h6>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
				</div>
				<div className="col-sm-6">
					<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.incomplete") + ' '}</b><span className="badge result-incomplete-sm"> </span></h6>
				</div>
			</div>
			<div className="row">
				{(traceabilityScoreData && traceabilityScoreData.length > 0) ? (
					<table style={{ margin: "20px" }}>
						<thead>
							<tr>
								<th>{t("page.tracepo")}</th>
								<th>{t("page.eval")}</th>
								<th>{t("page.shipdate")}</th>
							</tr>
						</thead>
						<tbody>
							{traceabilityScoreData.map((traceabilityScore) => (
								<tr>
									<td>{traceabilityScore.traceability}</td>
									<td bgColor={(traceabilityScore.scoreResult === 'L' ? lowColor : (traceabilityScore.scoreResult === 'H' ? highColor : (traceabilityScore.scoreResult === 'M' ? medColor : noColor)))}></td>
									<td>{traceabilityScore.shippingDate}</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (<></>)
				}
			</div>
			<div className="row" id="reportContainer" style={{ marginTop: "2vh" }}>
				<div className="col">
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div className="placeholder-pg"></div>
				</div>
			</div>
		</div>
	)
}

export default DisplayShippingChart;